const microAppFunction = (functionName, request = {}) => {
  let err = ''
  if (!microapps) {
    err = 'MICROAPPS NOT PRESENT'
  } else if (!microapps[functionName]) {
    console.error(
      'ERR: ',
      'FUNCTION NOT PRESENT IN MICROAPPS ',
      functionName,
      microapps,
    )
    err = `FUNCTION NOT PRESENT IN MICROAPPS ${functionName}`
  } else if (!['function', 'object'].includes(typeof microapps[functionName])) {
    console.error(
      'ERR: ',
      'FUNCTION PRESENT IN MICROAPPS BUT IS OF INCORRECT TYPE ',
      functionName,
      typeof microapps[functionName],
      microapps,
    )
    err = `FUNCTION PRESENT IN MICROAPPS BUT IS OF INCORRECT TYPE ${functionName} ${typeof microapps[
      functionName
    ]}`
  } else {
    return request
      ? microapps[functionName](request)
      : microapps[functionName]()
  }
  return Promise.reject(err)
}

const getCurrentLocation = (cb) => {
  try {
    microAppFunction('getCurrentLocation')
      .then((response) => {
        cb(null, response)
      })
      .catch((error) => {
        console.error('ERR: getCurrentLocation: An error occurred: ', error)
        cb(error)
      })
  } catch (err) {
    console.error('ERROR: GPAY: in getCurrentLocation', err)
  }
}

const getPhoneNumber = (cb, request = {}) => {
  try {
    microAppFunction('getPhoneNumber', request)
      .then((response) => {
        // console.log('getPhoneNumber response encoded: ', response);
        // const decoded = JSON.parse(atob(response.split('.')[1]));
        // console.log('getPhoneNumber response decoded: ', decoded);
        cb(null, response)
      })
      .catch((error) => {
        console.error('ERR: getPhoneNumber: An error occurred: ', error)
        cb(error)
      })
  } catch (err) {
    console.error('ERROR: GPAY: in getPhoneNumber', err)
  }
}

const getIdentity = (cb) => {
  try {
    // skipPrompt : parameter
    // console.log('GPAY getIdentity startd...', typeof cb);
    const request = {}
    microAppFunction('getIdentity', request)
      .then((response) => {
        // console.log('getIdentity response encoded: ', response);
        // Decode JWT token to get details and and make api request to backend.
        cb(null, response)
      })
      .catch((error) => {
        console.error('ERR: getIdentity: An error occurred: ', error)
        cb(error)
      })
  } catch (err) {
    console.error('ERROR: GPAY: in getIdentity', err)
  }
}

export default {
  getCurrentLocation,
  getPhoneNumber,
  getIdentity,
}
